/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PHIRectangle
 */
export interface PHIRectangle {
    /**
     * 
     * @type {number}
     * @memberof PHIRectangle
     */
    x?: number;
    /**
     * 
     * @type {number}
     * @memberof PHIRectangle
     */
    y?: number;
    /**
     * 
     * @type {number}
     * @memberof PHIRectangle
     */
    w?: number;
    /**
     * 
     * @type {number}
     * @memberof PHIRectangle
     */
    h?: number;
    /**
     * 
     * @type {number}
     * @memberof PHIRectangle
     */
    pW?: number;
    /**
     * 
     * @type {number}
     * @memberof PHIRectangle
     */
    pH?: number;
    /**
     * 
     * @type {number}
     * @memberof PHIRectangle
     */
    page?: number;
}

/**
 * Check if a given object implements the PHIRectangle interface.
 */
export function instanceOfPHIRectangle(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PHIRectangleFromJSON(json: any): PHIRectangle {
    return PHIRectangleFromJSONTyped(json, false);
}

export function PHIRectangleFromJSONTyped(json: any, ignoreDiscriminator: boolean): PHIRectangle {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'x': !exists(json, 'x') ? undefined : json['x'],
        'y': !exists(json, 'y') ? undefined : json['y'],
        'w': !exists(json, 'w') ? undefined : json['w'],
        'h': !exists(json, 'h') ? undefined : json['h'],
        'pW': !exists(json, 'pW') ? undefined : json['pW'],
        'pH': !exists(json, 'pH') ? undefined : json['pH'],
        'page': !exists(json, 'page') ? undefined : json['page'],
    };
}

export function PHIRectangleToJSON(value?: PHIRectangle | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'x': value.x,
        'y': value.y,
        'w': value.w,
        'h': value.h,
        'pW': value.pW,
        'pH': value.pH,
        'page': value.page,
    };
}

